import { useEffect, useRef, useState } from "react";

const navItems = [
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export default function Navigation() {
  const navigationRef = useRef(null);
  const [isInverted, setIsInverted] = useState(false);

  useEffect(() => {
    const navigation = navigationRef.current;
    const contact = document.getElementById("contact");
    if (!navigation || !contact) return undefined;

    let frame = 0;

    const updateContrast = () => {
      frame = 0;
      const navigationBounds = navigation.getBoundingClientRect();
      const contactBounds = contact.getBoundingClientRect();
      const navigationMidpoint =
        navigationBounds.top + navigationBounds.height / 2;

      setIsInverted(
        contactBounds.top <= navigationMidpoint &&
          contactBounds.bottom > navigationMidpoint,
      );
    };

    const scheduleUpdate = () => {
      if (frame === 0) frame = requestAnimationFrame(updateContrast);
    };

    updateContrast();
    window.addEventListener("scroll", scheduleUpdate, { passive: true });
    window.addEventListener("resize", scheduleUpdate, { passive: true });

    return () => {
      window.removeEventListener("scroll", scheduleUpdate);
      window.removeEventListener("resize", scheduleUpdate);
      if (frame !== 0) cancelAnimationFrame(frame);
    };
  }, []);

  return (
    <header
      className={`navigation${isInverted ? " navigation--inverted" : ""}`}
      ref={navigationRef}
    >
      <a className="navigation__monogram" href="#top" aria-label="Back to top">
        ES
      </a>
      <nav aria-label="Primary navigation">
        <ul className="navigation__list">
          {navItems.map((item) => (
            <li key={item.href}>
              <a className="navigation__link" href={item.href}>
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}
